import { writable } from 'svelte/store';
export const title = writable('');
export const setTitle = (newTitle) => title.set(newTitle);
